import { config } from "../env";
import {
  Delete,
  DeletePayload,
  get,
  patch,
  post,
  postFileUpload,
} from "./helpers/http-handler";

export const clientCreateVendor = (payload: object) =>
  post(`${config.API_URL}/vendors`, payload);

export const clientGetVendor = (queryRequest: string) =>
  get(`${config.API_URL}/vendors?${queryRequest}`);

export const clientGetSpecificVendor = (id: string) =>
  get(`${config.API_URL}/vendors/${id}`);

export const clientUpdateSpecificVendor = (id: string, payload: object) =>
  patch(`${config.API_URL}/vendors/${id}`, payload);

export const clientUpdateBulkStatusVendor = (payload: object) =>
  patch(`${config.API_URL}/vendors/bulk/active-inactive`, payload);

export const clientAttachLocationToVendor = (id: string, payload: object) =>
  patch(`${config.API_URL}/vendors/${id}/location/attach`, payload);

export const clientGetAttachedLocationToVendor = (
  id: string,
  queryRequest: string,
) => get(`${config.API_URL}/vendors/${id}/attachedLocation?${queryRequest}`);

export const clientGetLocationMapEmailsToVendor = (
  vendor_id: string,
  queryRequest: string,
) => get(`${config.API_URL}/locations/list/emails?vendor_id=${vendor_id}`);

export const clientDeleteAttachedLocationToVendor = (
  id: string,
  payload: object,
) => DeletePayload(`${config.API_URL}/vendors/${id}/location/remove`, payload);

export const adminBulkUpdateVendorStatus = (payload: object) =>
  patch(`${config.API_URL}/vendors/bulk/active-inactive`, payload);

export const getUserEmailList = (queryRequest: string) =>
  get(`${config.API_URL}/users/emails?${queryRequest}`);

// head counts

export const clientCreateHeadCount = (payload: object) =>
  post(`${config.API_URL}/headcounts`, payload);

export const clientCreateVerifiedHeadCount = (payload: object) =>
  patch(`${config.API_URL}/headcounts/update/verified-hc`, payload);

export const clientGetHeadcount = (queryRequest: string) =>
  get(`${config.API_URL}/headcounts?${queryRequest}`);

export const clientGetSpecificHeadCount = (id: string) =>
  get(`${config.API_URL}/headcounts/${id}`);

export const clientUpdateSpecificHeadCount = (id: string, payload: object) =>
  patch(`${config.API_URL}/headcounts/${id}`, payload);

export const clientDeleteSpecificHeadCount = (id: string) =>
  Delete(`${config.API_URL}/headcounts/${id}`);

export const clientDeleteBulkHeadCount = (payload: object) =>
  patch(`${config.API_URL}/headcounts/bulk/delete`, payload);

// upload

export const uploadVendors = (payload: object, source: string) =>
  postFileUpload(`${config.API_URL}/vendors/import`, payload, source);

export const uploadVendorsLocation = (payload: object, source: string) =>
  postFileUpload(`${config.API_URL}/vendors/location-import`, payload, source);

export const uploadVendorsHeadcount = (payload: object, source: string) =>
  postFileUpload(`${config.API_URL}/headcounts/import`, payload, source);

export const uploadVendorsUsers = (payload: object, source: string) =>
  postFileUpload(`${config.API_URL}/users/import`, payload, source);

export const getTemplates = (queryRequest: string) =>
  get(`${config.API_URL}/templates?${queryRequest}`);

export const getICCheckpointTemplates = (queryRequest: string) =>
  get(`${config.API_URL}/ic-checkpoint/export/template?${queryRequest}`);

// users change Email

export const clientVendorChangeEmail = (payload: object) =>
  patch(`${config.API_URL}/users/change/email`, payload);

export const clientVendorVerifyEmail = (payload: object) =>
  patch(`${config.API_URL}/users/email/otp-verify`, payload);

export const getDashboardInfo = (payload: object) =>
  post(`${config.API_URL}/vendor-checkpoint/dashboard-info`, payload);

// export

export const exportVendors = (payload: object) =>
  post(`${config.API_URL}/reports/export-vendors`, payload);

//Repo Vendor Compliance Filter
export const getVendorFilterLocationList = (queryRequest: string) =>
  get(`${config.API_URL}/vendors/location/filter?${queryRequest}`);

//Create Email Mapping for Vendor
export const clientVendorEmailMapping = (payload: object) =>
  post(`${config.API_URL}/locations/location/emails`, payload);

export const getClientVendorEmailMapping = (
  location_id: string,
  vendor_id: string,
) => get(`${config.API_URL}/locations/${location_id}/${vendor_id}/emails`);

export const exportVendorsUser = (payload: object) =>
  post(`${config.API_URL}/reports/export-User-Report`, payload);

export const exportVendorEmailMapping = (queryRequest: string) =>
  get(`${config.API_URL}/locations/export/email-mapping?${queryRequest}`);
